module.exports = __webpack_public_path__ + "img/hangyeniushang.a4bf777f.png";